<template>
    <div class="container-fluid">
        <div class="row" style="padding:10px 0 10px 60px;background-color:white;">
            <div class="col-6">
                <img src="../../../public/img/logo-hki.png" width="100px" height="50px" style="float:left;padding-right:10px;" />                
                <span style="display:block; padding-top:5px;">e-HakCipta Kekayaan Intelektual</span>
                <span style="display:block;">Direktorat Jenderal Kekayaan Intelektual</span>                
            </div>            
        </div>


        <div class="row justify-content-center">   
            <div class="col-3" style="margin-top:25px;">
                <table>
                    <tr>
                        <td colspan="3" style="text-align:center;">Download Sertifikat</td>
                    </tr>
                    <tr>
                        <td>Masukkan Password</td>
                        <td>:</td>
                        <td><input type="password" v-model="pass"></td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <base-button
                                @click="download()"
                                native-type="button"
                                type="primary"
                                class="mb-3"
                                size="lg"
                                block
                                style="
                                color: #313e5e !important;
                                border: 0.2px solid #313e5eb !important;
                                "
                            >
                                Download
                            </base-button>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import api from './api';
import {Loading} from "element-ui";

export default{
    data(){
        return {
            pass : ''
        }
    },
    methods: {
        async loadData(data){
            var res = await api.getQRFrontPage(data);
            if (res.data.length > 0){
                this.fpdata = res.data[0];
                let inventors = this.fpdata.INVENTORS.split("#DELIMITERINV#");
                let arrinvent = [];
                for (let i=0; i<inventors.length; i++){
                    let pinvent = inventors[i].split("#DELIMITERPERSON#");
                    arrinvent.push({NAME:pinvent[0], ADDR:pinvent[1], NATION:pinvent[2]});
                }
                this.fpdata['INVENTORS'] = arrinvent;
                let owner = this.fpdata.OWNER.split("#DELIMITERPERSON#");
                this.fpdata['OWNER'] = {NAME:owner[0], ADDR:owner[1], NATION:owner[2]};

            }else
                this.fpdata = res.data;
        }, 
        async download(){
            let loadprg = Loading.service({
                fullscreen: true,
                lock: true,
                text: "Silahkan Menunggu .. Sedang Mengunduh Sertifikat ..",
                spinner: "el-icon-loading",
            });
            await api.sertifikasiDownload(this.$route.params.code + `?pass=${this.pass}`, loadprg);
        }
    },
    async mounted(){
      //await this.loadData(this.$route.params.code);    
    },
}
</script>


<style>
    body {
        background-color:#EDEEE1;
        color:black;
    }

    a{
        color: red;
    }
</style>